import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse, GetProviderTagsResponse } from '@magnetar/admin-api-interfaces'

interface UseProviderTagsParams {
  providerId?: number | null
  type?: 'clinic'
}

/**
 * 取得指定 (provider, type) 的標籤名稱清單，給 TagInput 的 autocomplete 使用。
 * - providerId 為 null/undefined 時不發請求，回傳空陣列。
 * - 後端對 sys_admin 要求帶 provider_id；對 provider user 直接從 JWT 解析。
 *   為了讓 admin 與 provider 行為一致，這個 hook 永遠帶 provider_id 進 URL。
 */
export function useProviderTags({ providerId, type = 'clinic' }: UseProviderTagsParams) {
  const { token } = useAuth()

  const url =
    token && providerId
      ? `/api/provider-tags?type=${type}&provider_id=${providerId}`
      : null

  const { data, error, isLoading, mutate } = useGet<ApiResponse<GetProviderTagsResponse>>(
    url,
    undefined,
    token ?? '',
  )

  return {
    tags: data?.data?.tags ?? [],
    isLoading,
    isError: error,
    mutate,
  }
}
